import React from 'react'
import { PropTypes } from 'prop-types'

import Button from 'components/UI/Button'
import { ContextMenuContext } from 'components/Navigation/ContextMenu/ContextMenuLogic'

import './context-menu-item.pcss'

const ContextMenuItem = ({
    className,
    children,
    onSelect,
    closeMenuOnClick,
    trackName,
}) => {
    return (
        <ContextMenuContext.Consumer>
            {contextMenu => (
                <Button
                    type="button"
                    className={'context-menu-item ' + className}
                    onClick={(e) => {
                        onSelect && onSelect(e)
                        closeMenuOnClick && contextMenu && contextMenu.actions.close()
                    }}
                    trackName={trackName}
                >
                    {children}
                </Button>
            )}
        </ContextMenuContext.Consumer>

    )
}

ContextMenuItem.propTypes = {
    className: PropTypes.string,
    trackName: PropTypes.string.isRequired,
    closeMenuOnClick: PropTypes.bool,
    onSelect: PropTypes.func,
}

ContextMenuItem.defaultProps = {
    closeMenuOnClick: true,
}

export default ContextMenuItem

export const ContextMenuSpacer = () => {
    return <div className="context-menu-spacer" />
}
